import { useEffect, useState } from "react";
import Slider from "react-slick";
import servicosImagens from "../../servicos/servicos-imagens";
import servicosProduto from "../../servicos/servicos-produto";
import { Link } from "react-router-dom";
import { basePath } from "../../utils/baseUrl";
import Spinner from "./Spinner";

function CarrosselHome(props) {
    const [produtos, setProdutos] = useState([]);
    const [imagens, setImagens] = useState([]);
    const [imagensCarrossel, setImagensCarrossel] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        servicosProduto
            .listarTodosCategoria1()
            .then((response) => {
                let aux = [];
                if (response.status === 200) {
                    for (const produto of imagens) {
                        let contem = false;
                        for (const iterator of response.data) {
                            if (String(produto.Produto[0].nome).trim() === String(iterator.nome).trim()) {
                                contem = true;
                            }
                        }
                        if (contem === true) {
                            if (aux.length < 26) {
                                aux.push(produto);
                            }
                        }
                    }
                    setProdutos(aux);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [imagens]);

    useEffect(() => {
        setIsLoading(true);
        servicosImagens
            .listarTodas()
            .then((response) => {
                if (response.status === 200) {
                    setImagens(response.data);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        setIsLoading(true);
        let aux = [];
        for (const produto of produtos) {
            for (const iterator of imagens) {
                if (produto.id_produto === iterator.id_produto) {
                    aux.push(iterator);
                }
            }
        }
        const filteredArray = aux.filter(
            (obj, index, self) =>
                index ===
                self.findIndex((o) => o.Produto[0].nome === obj.Produto[0].nome)
        );
        setImagensCarrossel(filteredArray);
        setTimeout(() => {
            setIsLoading(false);
          }, 1000);
    }, [produtos, imagens]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 4000,
        width: 1000,
        responsive: [

            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerMode: false,
                    centerPadding: "0px",
                },
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerMode: true,
                    centerPadding: "-20px",
                    width: "740px",
                },
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerMode: true,
                    centerPadding: "-30px",
                    width: "990px",
                },
            },
            {
                breakpoint: 1364,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerMode: false,
                    centerPadding: "0px",
                    width: "80vw",
                },
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerMode: false,
                    centerPadding: "0px",
                    width: "95vw",
                },
            },
        ],
    };

    return (
        <>
            {isLoading ? <div className="container mt-5 d-flex justify-content-center align-items-center"><Spinner mensagem="Carregando lista de produtos" /></div> : <div className="carrossel-home container mt-5">
                
                <Slider {...settings} >
                    {imagensCarrossel.map((produto) => {
                        if (produto.filename) {
                            return (
                                <Link key={produto.id_produto} to={"/CardProduto"} state={{ produto }} >
                                    <div className="card border-0  " style={{ width: props.tamano || 330, height: props.tamanho || 300, backgroundColor: '#f7f2ff' }}>
                                        <img src={`${basePath}/${produto.filename}`} style={{ width: props.tamanho || 300, height: props.tamanho || 250 }} className="card-img-top " alt="..." />
                                        <div className="card-body">
                                            <p className="card-text">{produto.Produto[0].nome}</p>
                                        </div>
                                    </div>
                                </Link>
                            );
                        } else {
                            return null;
                        }
                    })}
                </Slider>
            </div>}
        </>
    );
}

export default CarrosselHome;